import type { BanWordsData } from './utils';

/**
 * 금지어 목록 — 배포 시점에 번들되는 정적 스냅샷.
 *
 * 과거에는 런타임에 weegloo CDA(`zep.us/weegloo/cda/...`)에서 매번 fetch 했으나,
 * (1) weegloo 500(SpelEvaluationException) 시 필터가 조용히 무력화되고
 * (2) play 등에서 불필요한 외부 의존/네트워크 왕복이 생겨 정적 번들로 전환했다.
 *
 * 로딩은 dynamic import 로 처리한다 → 105KB 목록이 초기 번들 크리티컬 패스에 들어가지
 * 않고, 필터가 실제로 필요한 시점(useZepBanWords 마운트)에 별도 청크로 1회만 로드된다.
 * 번들 청크라 네트워크 실패(404/오프라인)로 필터가 꺼질 위험이 없다.
 *
 * 목록 갱신은 이 JSON 을 교체(재배포)할 때만 반영된다.
 * 갱신 절차: weegloo CDA content `Se0Sb3wK876tUl8Dq2jUEPE` 의 `fields.json`(blackList/whiteList/isolated/inner)을
 * 받아 `ban-words.json` 을 덮어쓰고 커밋 → 배포.
 */
let cached: BanWordsData | null = null;
let loading: Promise<BanWordsData> | null = null;

export const fetchBanWords = async (): Promise<BanWordsData> => {
  if (cached) return cached;
  if (loading) return loading;

  loading = import('./ban-words.json')
    .then(module => {
      cached = (module.default ?? module) as BanWordsData;
      return cached;
    })
    .finally(() => {
      loading = null;
    });

  return loading;
};
